import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-worksheet-page',
  templateUrl: './worksheet-page.component.html',
  styleUrl: './worksheet-page.component.scss',
})
export class WorksheetPageComponent {
  constructor(private router: Router) {}
  isWorksheetPage: boolean;
  isGalleryPage: boolean;
  ngOnInit() {
    this.isWorksheetPage = this.router.url.includes('worksheet');
    this.isGalleryPage = this.router.url.includes('gallery');
  }
}
